import React from 'react'

import { ReactComponent as FilterSvg } from '../../assets/filter.svg'
import { ReactComponent as OrderSvg } from '../../assets/order.svg'
import { ReactComponent as ArrowUpSvg } from '../../assets/arrow-up.svg'
import { ReactComponent as ArrowDownSvg } from '../../assets/arrow-down.svg'

import { Container } from './styles'

interface IFilterButtonProps {
    onClick?: () => void;
    counter?: number;
    shouldUseArrow?: boolean;
    isOpen?: boolean;
    orderSvg?: boolean;
}

const FilterButton: React.FC<IFilterButtonProps> = ({ counter, onClick, isOpen, shouldUseArrow, orderSvg, children }) => (
    <Container onClick={onClick} isPointer={!!onClick}>
        {!orderSvg ? <FilterSvg className='filter_svg' /> : <OrderSvg className='filter_svg' />}

        {children || 'Filtrar'}

        {shouldUseArrow && isOpen ? <ArrowUpSvg className='arrow_svg' /> : <ArrowDownSvg className='arrow_svg' />}

        {!!counter && <span> {counter} </span>}
    </Container>
)


export default FilterButton